<template>
<div class="con">
  <div class="unregular-wrp clear">

    <div class="lft">
      <div class="bdgWrp">

        <div class="d-none" style="impersonate">
          <button class="light peiso-pink-button" @click="impersonate">
              Impersonate
          </button>
        </div>

        <div class="columns clear">
          <div class="column">
            <h2>Venue ID</h2>
            <h3>{{data.parentId ? data.parentId + ' - ' + data.id : data.id}}</h3>
            <h2>Venue Name</h2>
            <h3>{{data.venueName ? data.venueName : '-'}}</h3>
            <h2>Username</h2>
            <h3>{{data.userName ? data.userName : '-'}}</h3>
            <h2>ABN</h2>
            <h3>{{data.abn ? data.abn : '-'}}</h3>
            <h2>Venue Address</h2>
            <h3>{{data.venueAddress}}</h3>
            <h2>Venue Timezone</h2>
            <h3>{{data.timezone ? data.timezone : '-' }}</h3>
            <h2>GST Rate</h2>
            <h3>{{data.gstRate ? data.gstRate + '%' : '-'}}</h3>
            <h2>Automated Reports Max allowed emails:</h2>
            <h3>{{ data.maxAutomatedEmails ? data.maxAutomatedEmails : 5 }}</h3>
          </div>
          <div class="column">
            <h2>Venue Owner</h2>
            <h3>{{data.venueOwner ? data.venueOwner : '-'}}</h3>
            <h2>Password</h2>
            <h3>{{data.password ? (showPassword ? data.password : data.hidePsd): '-'}}<span @click="showPassword = !showPassword" :class="{'show': showPassword}"></span></h3>
            <h2>Contact Number</h2>
            <h3>{{data.venueMobile ? data.venueMobile : '-'}}</h3>
            <h2>Registration Time</h2>
            <h3>{{data.createTime ? data.createTime : '-'}}</h3>
          </div>
        </div>
      </div>
    </div>
    <div class="rgt">
      <div class="bdgWrp">
        <div class="d-flex flex-column gap-16">
          <!-- <div>
            <h2>Venue subscription</h2>
            <div class="subscription-label d-flex align-items-center justify-content-between gap-10">
              <span>Peiso {{ data.isPro ? 'Pro ' : 'Lite ' }} Version</span>

              <button class="light peiso-pink-button" @click="upgradeToLiteAndPro(data.isPro ? 0 : 1)" :disabled="isLoading">
                {{ data.isPro ? 'Downgrade' : 'Upgrade' }}
              </button>
            </div>
          </div> -->

          <!-- <div>
            <h2>Venue Settings</h2>
            <div v-for="(item) in list" :key="item.value" class="subscription-label d-flex align-items-center justify-content-between gap-10">
              <span>{{item.label}}</span>

              <button class="light peiso-pink-button" @click="selectIt(item.value)">
                {{ item.selected ? 'Activated' : 'Deactivated' }}
              </button>
            </div>
          </div> -->

          <!-- <div>
            <h2>Other feature</h2>
            <div class="subscription-label d-flex align-items-center justify-content-between gap-10">
              <span>Activate Cash up and banking</span>

              <button class="light peiso-pink-button" @click="enableCashupBanking(data.isCashUpActivated ? 0 : 1  )" :disabled="isLoading">
                {{ data.isCashUpActivated ? 'Deactivate' : 'Activate' }}
              </button>
            </div>
          </div> -->

          <div>
            <h2>Venue subscription</h2>
              <!-- <ul class="select-area">
                <li :class="{'selected': data.isPro}"
                @click="peisoLiteProController()">Peiso {{ data.isPro ? 'Pro ' : 'Lite ' }} Version</li>
              </ul> -->

              <peiso-toggle v-model="data.isPro" @change-toggle="showPeisoLiteAlert = true" labelTitle="Peiso venue application version" activeText="Pro" inactiveText="Lite"></peiso-toggle>

          </div>

          <div v-if="isEnableSplitEod || isEnableCashup">
            <h2>Reports</h2>
              <!-- <ul class="select-area">
                <li :class="{'selected': data.isEodSplitActivated}"
                @click="showSplitEod = true">Activate split EOD</li>

                <li :class="{'selected': data.isCashUpActivated && data.isCashUpDefaultActivated}" v-if="isEnableCashup"
                @click="showCashupAlert = true">Activate Cash up default</li>


                <li :class="{'selected': data.isCashUpActivated && data.isCashUpBennelongActivated}" v-if="isEnableCashup"
                @click="showCashupBennelongAlert = true">Activate Cash up Bennelong</li>
              </ul> -->
              <peiso-toggle v-model="data.isEodSplitActivated" v-if="isEnableSplitEod" @change-toggle="showSplitEod = true" labelTitle="Activate split EOD" activeText="Enable" inactiveText="Disable"></peiso-toggle>

              <peiso-toggle v-model="data.isCashUpDefaultActivated" v-if="isEnableCashup" @change-toggle="showCashupAlert = true" labelTitle="Activate Cash up default" activeText="Enable" inactiveText="Disable"></peiso-toggle>

              <peiso-toggle v-model="data.isCashUpBennelongActivated" v-if="isEnableCashup" @change-toggle="showCashupBennelongAlert = true" labelTitle="Activate Cash up Bennelong" activeText="Enable" inactiveText="Disable"></peiso-toggle>

              <peiso-toggle v-model="data.enableDeputySalaryStaff" @change-toggle="isEnableDeputySalary = true" labelTitle="Enable deputy salary staff feature" activeText="Enable" inactiveText="Disable"></peiso-toggle>
          </div>

          <div>
            <h2>Other feature</h2>
              <!-- <ul class="select-area">
                <li :class="{'selected': data.isBudgetingActivated}"
                @click="showBudgetingAlert = true">Activate Budgeting tool</li>
                <li :class="{'selected': data.isRevenueTargetForecastActivated}"
                @click="showRevenueForecastingAlert = true">Activate Revenue forecasting</li>
              </ul> -->

              <peiso-toggle class="width-200px" v-model="data.isBudgetingActivated" @change-toggle="showBudgetingAlert = true" labelTitle="Activate Budgeting tool" activeText="Activate" inactiveText="Deactivate"></peiso-toggle>

              <peiso-toggle class="width-200px" v-model="data.isRevenueTargetForecastActivated" @change-toggle="showRevenueForecastingAlert = true" labelTitle="Activate Revenue forecasting" activeText="Activate" inactiveText="Deactivate"></peiso-toggle>

              <peiso-toggle class="width-200px" v-model="data.isAccountingPlatformActivated" @change-toggle="showXero = true" labelTitle="Activate accounting platform" activeText="Activate" inactiveText="Deactivate"></peiso-toggle>

              <peiso-toggle class="width-200px" v-model="data.isManualJournalActivated" @change-toggle="showManualJournalAlert = true" labelTitle="Activate Manual Journal" activeText="Activate" inactiveText="Deactivate"></peiso-toggle>
          </div>

          <div>
            <h2>Venue Settings</h2>
              <!-- <ul class="select-area">
                <li v-for="(item) in list" :key="item.value" :class="{'selected': item.selected}"
                @click="selectIt(item.value)">{{item.label}}</li>
                <li :class="{'selected': data.isAccountingPlatformActivated}" @click="showXero = true">Activate accounting platform</li>
              </ul> -->

              <peiso-toggle v-for="(item, i) in list" :key="`${i}`" class="width-200px" v-model="item.selected" @change-toggle="selectIt(item.value)" :labelTitle="item.label" activeText="Activate" inactiveText="Deactivate"></peiso-toggle>

          </div>


        </div>
      </div>
    </div>
  </div>
  <div class="bdgWrp">
    <div class="columns clear">
      <div class="column">
        <h2>Venue Description</h2>
        <h3>{{data.venueDescription ? data.venueDescription : '-'}}</h3>
        <h2>Cuisine Type</h2>
        <h3>{{data.cuisineType ? data.cuisineType : '-'}}</h3>
      </div>
    </div>
  </div>
  <div class="bdgWrp">
    <div class="columns clear">
      <div class="column">
        <h2>Website</h2>
        <h3>{{data.website ? data.website : '-'}}</h3>
        <h2>Facebook Page</h2>
        <h3>{{data.facebookPage ? data.facebookPage : '-'}}</h3>
      </div>
      <div class="column">
        <h2>Instagram Username</h2>
        <h3>{{data.instagramUsername ? data.instagramUsername : '-'}}</h3>
      </div>
    </div>
  </div>
  <div class="bdgWrp d-none">
    <div class="columns clear">
      <div class="column">
        <h2>Lease End Date</h2>
        <h3>{{data.leaseEndDate ? data.leaseEndDate : '-'}}</h3>
        <h2>Monthly Rental Cost</h2>
        <h3>{{data.monthlyRentalCost ? '$' + data.monthlyRentalCost : '-'}}</h3>
        <h2>Yearly Rental Increase Date</h2>
        <h3>{{data.yearlyRentalIncreaseDate ? data.yearlyRentalIncreaseDate : '-'}}</h3>
        <h2>Additional Amount</h2>
        <h3>{{data.additionalAmount ? '$' + data.additionalAmount : '-'}}</h3>
      </div>
      <div class="column">
        <h2>Does the Rental Agreement include outgoings?</h2>
        <h3>{{data.includeOutgoings === 0 ? 'No' : 'Yes'}}</h3>
        <h2>Yearly Rental Increase In % Or $ Value</h2>
        <h3>{{data.yearlyRentalIncrease !== null ? (data.yearlyRentalIncreaseType === 1 ? data.yearlyRentalIncrease + '%' : '$' + data.yearlyRentalIncrease) : '-'}}</h3>
        <h2>Rent Free Period</h2>
        <h3>{{data.rentFreePeriod ? (data.rentFreePeriod + ' months') : '-'}}</h3>
        <h2>Date of Agreement to T&Cs</h2>
        <h3>{{data.agreeToTheAgreementTime ? data.agreeToTheAgreementTime : '-'}}</h3>
      </div>
    </div>
  </div>
  <div class="bdgWrp">
    <div class="columns clear">
      <div class="column">
        <h2>Card Details</h2>
        <h3>{{data.cardNumber ? data.cardNumber : '-'}}</h3>
      </div>
      <div class="column">
        <h2>Monthly Fee</h2>
        <h3>{{data.monthlyFee ? '$' + data.monthlyFee : '-'}}</h3>
      </div>
    </div>
  </div>
  <div class="bdgWrp">
    <div class="columns clear">
      <div class="column" style="width:100%">
        <h2>Opening Hours</h2>
        <div class="edit-table edit-table-show">
          <el-table
              :data="tableData"
              border
              style="width: 100%">
            <el-table-column
              prop="week"
              label="WEEK"
              width="130"
              class-name="alignCenter">
            </el-table-column>
            <el-table-column
              label="TIME"
              width="448">
              <template slot-scope="scope">
                <span v-if="scope.row.time">{{scope.row.time}}</span>
                <span v-else>Closed</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
  <div class="bot clear">
    <button class="dark right remove" @click="showd = true">Remove</button>
    <button class="dark" @click="show = true" v-if="userable === 1">Disable</button>
    <button class="dark" @click="update" v-if="userable === 0">Enable</button>
    <button class="light" @click="edit">Edit</button>
  </div>

  <el-dialog
        title="Disabling this account will prevent users from signing in.
Are you sure you want to continue?"
        :visible.sync="show"
        :modal-append-to-body="false"
        :show-close="false"
        class="delsmsDio_box"
        :close-on-click-modal="false"
        width="740px"
        center>
            <div class="foot_box">
                <el-button @click="show=false" class="cardCanBtn">Cancel</el-button>
                <el-button @click="update" class="cardConBtn">Confirm</el-button>
            </div>
</el-dialog>

<el-dialog
        title="By deleting the account, you will also delete all content
 Are you sure you want to continue?"
        :visible.sync="showd"
        :modal-append-to-body="false"
        :show-close="false"
        class="delsmsDio_box"
        :close-on-click-modal="false"
        width="740px"
        center>
            <div class="foot_box">
                <el-button @click="showd=false" class="cardCanBtn">Cancel</el-button>
                <el-button @click="remove" class="cardConBtn">Delete</el-button>
            </div>
</el-dialog>
<!-- <el-dialog
        :title="`Do you want to ${ data.isAccountingPlatformActivated ? 'Deactivate' : 'Activate' } accounting platform for this venue?`"
        :visible.sync="showXero"
        :modal-append-to-body="false"
        :show-close="false"
        class="delsmsDio_box"
        :close-on-click-modal="false"
        width="740px"
        center>
            <div class="foot_box">
                <el-button @click="showXero = false" class="cardCanBtn">Cancel</el-button>
                <el-button v-if="!isLoadingMessage" @click="activateAccountingPlatform(data.isAccountingPlatformActivated ? 0 : 1)" class="cardConBtn">
                  {{ data.isAccountingPlatformActivated ? 'Deactivate' : 'Activate' }}
                </el-button>
                <el-button v-if="isLoadingMessage" class="cardConBtn cursor-disable">
                  <i class="el-icon-loading" style="font-size:20px"></i> {{ data.isAccountingPlatformActivated ? 'Deactivating...' : 'Activating...' }}
                </el-button>
            </div>
</el-dialog> -->

<message-alert :title="`Do you want to ${ data.isPro ? 'Downgrade this venue from Pro to Lite?' : 'Upgrade this venue from Lite to Pro?' }`" :isActivate="data.isPro" :btnLabel="data.isPro ? 'Downgrade' : 'Upgrade'" :btnLabelLoading="data.isPro ? 'Downgrading...' : 'Upgrading...'" :show="showPeisoLiteAlert" @close="showPeisoLiteAlert = false" :isLoadingMessage="isLoadingMessage" @handleTrigger="upgradeToLiteAndPro(data.isPro ? 0 : 1)"></message-alert>
<message-alert :title="`Do you want to ${ data.isEodSplitActivated ? 'deactivate' : 'activate' } split lunch dinner EOD?`" :isActivate="data.isEodSplitActivated" :btnLabel="data.isEodSplitActivated ? 'Deactivate' : 'Activate'" :btnLabelLoading="data.isEodSplitActivated ? 'Deactivating...' : 'Activating...'" :show="showSplitEod" @close="showSplitEod = false" :isLoadingMessage="isLoadingMessage" @handleTrigger="activateEodSplit(data.isEodSplitActivated ? 0 : 1  )"></message-alert>
<message-alert :title="`Do you want to ${ data.isCashUpActivated ? 'deactivate' : 'activate' } Cash up and Banking Feature?`" :isActivate="data.isCashUpActivated" :btnLabel="data.isCashUpActivated ? 'Deactivate' : 'Activate'" :btnLabelLoading="data.isCashUpActivated ? 'Deactivating...' : 'Activating...'" :show="showCashupAlert" @close="showCashupAlert = false" :isLoadingMessage="isLoadingMessage" @handleTrigger="enableCashupBanking(data.isCashUpActivated ? 0 : 1  )"></message-alert>
<message-alert :title="`Do you want to ${ data.isBudgetingActivated ? 'deactivate' : 'activate' } Budgeting Tool Feature?`" :isActivate="data.isBudgetingActivated" :btnLabel="data.isBudgetingActivated ? 'Deactivate' : 'Activate'" :btnLabelLoading="data.isBudgetingActivated ? 'Deactivating...' : 'Activating...'" :show="showBudgetingAlert" @close="showBudgetingAlert = false" :isLoadingMessage="isLoadingMessage" @handleTrigger="enableBudgetingTool(data.isBudgetingActivated ? 0 : 1  )"></message-alert>
<message-alert :title="`Do you want to ${ data.isRevenueTargetForecastActivated ? 'deactivate' : 'activate' } Revenue Forecasting Feature?`" :isActivate="data.isRevenueTargetForecastActivated" :btnLabel="data.isRevenueTargetForecastActivated ? 'Deactivate' : 'Activate'" :btnLabelLoading="data.isRevenueTargetForecastActivated ? 'Deactivating...' : 'Activating...'" :show="showRevenueForecastingAlert" @close="showRevenueForecastingAlert = false" :isLoadingMessage="isLoadingMessage" @handleTrigger="enableRevenueForecasting(data.isRevenueTargetForecastActivated ? 0 : 1  )"></message-alert>
<message-alert :title="`Do you want to ${ data.isAccountingPlatformActivated ? 'hide' : 'show' } accounting platform for this venue?`" :isActivate="data.isAccountingPlatformActivated" :btnLabel="data.isAccountingPlatformActivated ? 'Hide' : 'Show'" :btnLabelLoading="data.isAccountingPlatformActivated ? 'Hiding...' : 'Showing...'" :show="showXero" @close="showXero = false" :isLoadingMessage="isLoadingMessage" @handleTrigger="activateAccountingPlatform(data.isAccountingPlatformActivated ? 0 : 1)"></message-alert>
<message-alert
  :title="`Do you want to ${ data.isManualJournalActivated ? 'deactivate' : 'activate' } Manual Journal Feature?`"
  :isActivate="data.isManualJournalActivated" :btnLabel="data.isManualJournalActivated ? 'Deactivate' : 'Activate'"
  :btnLabelLoading="data.isManualJournalActivated ? 'Deactivating...' : 'Activating...'"
  :show="showManualJournalAlert"
  @close="showManualJournalAlert = false"
  :isLoadingMessage="isLoadingMessage"
  @handleTrigger="enableManualJournal(data.isManualJournalActivated ? 0 : 1  )">
</message-alert>
<message-alert :title="`Do you want to ${ data.isCashUpBennelongActivated ? 'deactivate' : 'activate' } Cash up bennelong?`" :isActivate="data.isCashUpBennelongActivated" :btnLabel="data.isCashUpBennelongActivated ? 'Deactivate' : 'Activate'" :btnLabelLoading="data.isCashUpBennelongActivated ? 'Deactivating...' : 'Activating...'" :show="showCashupBennelongAlert" @close="showCashupBennelongAlert = false" :isLoadingMessage="isLoadingMessage" @handleTrigger="enableCashupBennelong(data.isCashUpBennelongActivated ? 0 : 1  )"></message-alert>
<message-alert :title="`Do you want to ${ data.enableDeputySalaryStaff ? 'disable' : 'enable' } deputy salary staff?`" :isActivate="data.enableDeputySalaryStaff" :btnLabel="data.enableDeputySalaryStaff ? 'Disable' : 'Enable'" :btnLabelLoading="data.enableDeputySalaryStaff ? 'Disabling...' : 'Enabling...'" :show="isEnableDeputySalary" @close="isEnableDeputySalary = false" :isLoadingMessage="isLoadingMessage" @handleTrigger="enableDeputySalaryStaff(data.enableDeputySalaryStaff ? 0 : 1  )"></message-alert>

</div>
</template>

<script>
import api from '../../../api/account';
import axios from 'axios';
import messageAlert from '@/components/modal/messageAlert';
import peisoToggle from '@/components/common/peisoToggle.vue';

const CASHUP_FORMAT_BENNELONG = 'otto';
const CASHUP_FORMAT_DEFAULT = 'default';

export default {
  inject: ['reload'],
  data () {
    return {
      list: [
        {
          selected: false,
          value: 0,
          label: 'Tick Activated Deputy Revenue',
          loading: false
        },
        {
          selected: false,
          value: 1,
          label: 'Tick Activated Manual P&L',
          loading: false
        },
        {
          selected: false,
          value: 2,
          label: 'Tick Activated Labour',
          loading: false
        }
      ],
      // 选中的时间段数据
      tableData: [],
      data: {},
      userable: null,
      show: false,
      showd:false,
      showPassword: false,
      isLoading: false,
      showXero: false,
      isLoadingMessage: false,
      showPeisoLiteAlert: false,
      showCashupAlert: false,
      showSplitEod: false,
      showBudgetingAlert: false,
      showCashupBennelongAlert: false,
      showRevenueForecastingAlert: false,
      showManualJournalAlert: false,
      isEnableCashup: process.env.IS_ENABLE_CASHUP == '1' ? true : false,
      isEnableSplitEod: process.env.IS_ENABLE_SPLIT_EOD == '1' ? true : false,
      isEnableDeputySalary: false,
    }
  },
  components: {
    messageAlert: messageAlert,
    peisoToggle: peisoToggle
  },
  created () {
    var that = this
    this.retrieveVenueInformation()
    // Tick Activated Manual P&L 状态获取
    /*api.profitLossOfYearList({
      params: {
        venueId: parseInt(this.$route.params.id)
      },
      callback: (res) => {
        if (res.data.code === 0) {
          that.list[1].selected = res.data.data.profitLossEdit === 1 ? true : false
        } else {
          Utils.alert('', res.data.message, 'error')
        }
      }
    })*/
    // Tick Activated Labour 状态获取
    /*api.weekdeputyRoster({
      params: {
        pageNum: 1,
        pageSize: 10,
        venueId: parseInt(this.$route.params.id)
      },
      callback: (res) => {
        if (res.data.code === 0) {
          that.list[2].selected = res.data.data.metadata === 0 ? false : true
        } else {
          Utils.alert('', res.data.message, 'error')
        }
      }
    })*/
  },
  methods: {
    impersonate() {
      api.signInVenue({
          password: this.data.password,
          userName: this.data.userName,
        }, this.impersonateCallback)
    },

    impersonateCallback (res) {
      if (res.data && res.data.code == 0) {

        const queryParams =  {...res.data.data, isImpersonate: true}
        let redirectUrl = process.env.WEB_URL + "/dashboard?";

        for (var key in queryParams) {
            if (queryParams.hasOwnProperty(key) && queryParams[key] !== null && queryParams[key] !== undefined) {
                redirectUrl += encodeURIComponent(key) + "=" + encodeURIComponent(queryParams[key]) + "&";
            }
        }
        // Remove the trailing "&" if there are query parameters
        if (redirectUrl.endsWith("&")) {
            redirectUrl = redirectUrl.slice(0, -1);
        }
        // Redirect to the new URL
        window.location.href = redirectUrl;
      }

    },

    selectIt(e) {
      var that = this
      if (e === 0 && !that.list[0].loading) {
        that.list[0].selected = !that.list[0].selected
        that.list[0].loading = true
        api.venueSetRevenueFrom({
          params: {
            venueId: this.$route.params.id,
            status: that.list[0].selected ? 2 : 1
          },
          callback: (res) => {
            that.list[0].loading = false
            if (res.data.code !== 0){
              that.list[0].selected = !that.list[0].selected
              Utils.alert('', res.data.message, 'error')
            }
          }
        })
      } else if (e === 1) {
        that.list[1].selected = !that.list[1].selected
        that.list[1].loading = true
        api.profitLossEdit({
          params: {
            venueId: this.$route.params.id,
            profitLossEdit: that.list[1].selected ? 1 : 0
          },
          callback: (res) => {
            that.list[1].loading = false
            if (res.data.code !== 0){
              that.list[1].selected = !that.list[1].selected
              Utils.alert('', res.data.message, 'error')
            }
          }
        })
      } else if (e === 2) {
        that.list[2].selected = !that.list[2].selected
        that.list[2].loading = true
        api.activatedLabour({
          params: {
            venueId: this.$route.params.id,
            tickActivatedLabour: that.list[2].selected ? 1 : 0
          },
          callback: (res) => {
            that.list[2].loading = false
            if (res.data.code !== 0){
              that.list[2].selected = !that.list[2].selected
              Utils.alert('', res.data.message, 'error')
            }
          }
        })
      }
    },
    retrieveVenueInformation() {
      this.isLoading = true
      api.venueAccntDetail({
        params: parseInt(this.$route.params.id),
        callback: this.callback
      })
    },
    callback(res) {
      var that = this
      if(res.data.code == 0){
        //
        /***************** 2022/12/7 start *****************/
        that.list[0].selected = res.data.data.revenueFrom === 1 ? false : true
        that.list[1].selected = res.data.data.profitLossEdit === 1 ? true : false
        that.list[2].selected = res.data.data.tickActivatedLabour === 0 ? false : true
        /***************** 2022/12/7 end *****************/
        let lgt = res.data.data.password.length
        res.data.data.hidePsd = ''
        for (let i = 0 ; i < lgt ; i ++) {
          res.data.data.hidePsd = res.data.data.hidePsd + '*'
        }
        res.data.data.venueMobile = that.$box.formatNumber(res.data.data.venueMobile)
        if (res.data.data.venueDescription.indexOf(',') !== -1) {
          res.data.data.venueDescription = res.data.data.venueDescription.split(',')
          let temp = []
          res.data.data.venueDescription.forEach(item => {
            if (item === 'Bar') {
              temp.push(item)
            } else if (item === 'Café' || item === 'Cafe') {
              temp.push('Café')
            } else {
              temp.push('Restaurant-' + item)
            }
          })
          res.data.data.venueDescription = temp.join('/')
        } else {
          if (res.data.data.venueDescription === 'Cafe')
            res.data.data.venueDescription = 'Café'
        }
        if (res.data.data.cuisineType.indexOf(',') !== -1) {
          res.data.data.cuisineType = res.data.data.cuisineType.split(',')
          res.data.data.cuisineType = res.data.data.cuisineType.join('/')
        }
        if (res.data.data.cardNumber && res.data.data.cardNumber.length === 15) {
          res.data.data.cardNumber = 'xxxx xxxxxx ' + res.data.data.cardNumber.slice(10)
        } else if (res.data.data.cardNumber && res.data.data.cardNumber.length === 16) {
          res.data.data.cardNumber = 'xxxx xxxx xxxx ' + res.data.data.cardNumber.slice(12)
        }

        res.data.data.leaseEndDate = Utils.formatdateminute(res.data.data.leaseEndDate * 1000)
        res.data.data.monthlyRentalCost = that.$box.fmoney(res.data.data.monthlyRentalCost)
        if (res.data.data.yearlyRentalIncreaseDate && typeof(res.data.data.yearlyRentalIncreaseDate) === 'string' && res.data.data.yearlyRentalIncreaseDate.indexOf('-') !== -1) {
          let temptime = res.data.data.yearlyRentalIncreaseDate.split('-')
          let M = temptime[0]
          if (M === '01') {
            M = 'Jan'
          } else if (M === '02') {
            M = 'Feb'
          } else if (M === '03') {
            M = 'Mar'
          } else if (M === '04') {
            M = 'Apr'
          } else if (M === '05') {
            M = 'May'
          } else if (M === '06') {
            M = 'Jun'
          } else if (M === '07') {
            M = 'Jul'
          } else if (M === '08') {
            M = 'Aug'
          } else if (M === '09') {
            M = 'Sep'
          } else if (M === '10') {
            M = 'Oct'
          } else if (M === '11') {
            M = 'Nov'
          } else if (M === '12') {
            M = 'Dec'
          }
          res.data.data.yearlyRentalIncreaseDate = temptime[1] + ' ' + M
        }
        res.data.data.additionalAmount = that.$box.fmoney(res.data.data.additionalAmount)
        res.data.data.monthlyFee = that.$box.fmoney(res.data.data.monthlyFee)
        if (res.data.data.abn)
          res.data.data.abn = res.data.data.abn.slice(0, 2) + ' ' + res.data.data.abn.slice(2, 5) + ' ' + res.data.data.abn.slice(5, 8) + ' ' + res.data.data.abn.slice(8, 11)
        if (res.data.data.yearlyRentalIncreaseType === 0) {
          res.data.data.yearlyRentalIncrease = that.$box.fmoney(res.data.data.yearlyRentalIncrease)
        }
        res.data.data.additionalAmount = that.$box.fmoney(res.data.data.additionalAmount)
        res.data.data.createTime = that.$box.timestampToTime(res.data.data.createTime)

        this.data = res.data.data

        // bennelong cashup
        if (res.data.data.isCashUpActivated) {
          this.data.isCashUpBennelongActivated = that.data.cashUpFormat == CASHUP_FORMAT_BENNELONG ? true : false;
          this.data.isCashUpDefaultActivated = that.data.cashUpFormat == CASHUP_FORMAT_DEFAULT ? true : false;
        } else {
          this.data.isCashUpBennelongActivated = false
          this.data.isCashUpDefaultActivated = false
        }

        if (res.data.data.gstRate) {
          this.data.gstRate = (res.data.data.gstRate * 100)
        }

        this.data.isPro = res.data.data.isPro ? true : false

        this.data.isEodSplitActivated = res.data.data.isEodSplitActivated ? true : false
        this.data.enableDeputySalaryStaff = res.data.data.enableDeputySalaryStaff ? true : false
        
        this.data.isBudgetingActivated = res.data.data.isBudgetingActivated ? true : false
        this.data.isRevenueTargetForecastActivated = res.data.data.isRevenueTargetForecastActivated ? true : false
        this.data.isAccountingPlatformActivated = res.data.data.isAccountingPlatformActivated ? true : false
        this.data.isManualJournalActivated = res.data.data.isManualJournalActivated ? true : false
        res.data.data.venueOpenList.forEach(item => {
          if (item.week === "Monday") {
            this.tableData.push({
              week: 'Mon', time: item.openTime === "Closed" ? '' : item.openTime
            })
          } else if (item.week === "Tuesday") {
            this.tableData.push({
              week: 'Tues', time: item.openTime === "Closed" ? '' : item.openTime
            })
          } else if (item.week === "Wednesday") {
            this.tableData.push({
              week: 'Wed', time: item.openTime === "Closed" ? '' : item.openTime
            })
          } else if (item.week === "Thursday") {
            this.tableData.push({
              week: 'Thu', time: item.openTime === "Closed" ? '' : item.openTime
            })
          } else if (item.week === "Friday") {
            this.tableData.push({
              week: 'Fri', time: item.openTime === "Closed" ? '' : item.openTime
            })
          } else if (item.week === "Saturday") {
            this.tableData.push({
              week: 'Sat', time: item.openTime === "Closed" ? '' : item.openTime
            })
          } else if (item.week === "Sunday") {
            this.tableData.push({
              week: 'Sun', time: item.openTime === "Closed" ? '' : item.openTime
            })
          }
        })
        if (res.data.data.agreeToTheAgreementTime)
          res.data.data.agreeToTheAgreementTime = that.$box.timestampToTime(res.data.data.agreeToTheAgreementTime * 1000)
        this.userable = res.data.data.isDisabled
      } else{
        Utils.alert('', res.data.message, 'error')
      }

      this.isLoading = false
    },
    edit() {
      this.$router.push(`/alter/${this.$route.params.id}`)
    },
    remove() {
      api.delUser({
        params: parseInt(this.$route.params.id),
        callback: this.delCallback
      })
    },
    delCallback (res) {
      var that = this
      if(res.data.code == 0){
        if (sessionStorage.getItem('page'))
          this.$router.push({name: 'account', params: {page: sessionStorage.getItem('page')}})
        else
          this.$router.push('/account')
      } else{
        Utils.alert('', res.data.message, 'error')
      }
    },
    update() {
      api.update({
        params: {
          id: parseInt(this.$route.params.id),
          isDisabled: this.userable === 1 ? 0 : 1 // 差这里
        },
        callback: this.updateCallback
      })
    },
    updateCallback(res) {
      var that = this
      this.show = false
      if(res.data.code == 0){
        this.userable = this.userable === 0 ? 1 : 0
      } else{
        Utils.alert('', res.data.message, 'error')
      }
    },

    upgradeToLiteAndPro(isPro) {
      var payload = {
        isPro: isPro,
        venueId: this.$route.params.id
      }
      this.isLoadingMessage = true
      api.update_app(payload).then((res) => {
        var data = res.data
        if(data.code == 0) {
          this.retrieveVenueInformation()
          Utils.alert('', data.message, 'success')
        }
        this.isLoadingMessage = false
        this.showPeisoLiteAlert = false
      })
    },

    enableCashupBanking(isCashUp) {
      var payload = {
        isCashUp: isCashUp,
        venueId: this.$route.params.id
      }
      this.isLoadingMessage = true
      api.activate_cashup(payload).then((res) => {
        this.retrieveVenueInformation()

        var data = res.data
        Utils.alert('', `Cash up and banking successfully ${isCashUp ? 'activated' : 'deactivated'}.`, 'success')
        this.isLoadingMessage = false
        this.showCashupAlert = false
      })
    },

    enableManualJournal(isManualJournal) {
      var payload = {
        isManualJournal: isManualJournal,
        venueId: this.$route.params.id
      }
      this.isLoadingMessage = true
      api.activate_manual_journal(payload).then((res) => {
        this.retrieveVenueInformation()
        var data = res.data
        Utils.alert('', `Manual Journal successfully ${isManualJournal ? 'activated' : 'deactivated'}.`, 'success')
        this.isLoadingMessage = false
        this.showManualJournalAlert = false
      })
    },


    enableCashupBennelong(isCashUpBennelong) {
      var payload = {
        isCashUp: this.data.isCashUpActivated,
        cashUpFormat: isCashUpBennelong ? CASHUP_FORMAT_BENNELONG : CASHUP_FORMAT_DEFAULT,
        venueId: this.$route.params.id
      }
      this.isLoadingMessage = true
      api.activate_cashup_bennelong(payload).then((res) => {
        this.retrieveVenueInformation()

        var data = res.data
        Utils.alert('', `Cash up successfully ${isCashUpBennelong ? 'activated' : 'deactivated'}.`, 'success')
        this.isLoadingMessage = false
        this.showCashupBennelongAlert = false
      })
    },

    enableBudgetingTool(isBudgetingActivated) {
      var payload = {
        isBudgeting: isBudgetingActivated,
        venueId: this.$route.params.id
      }
      this.isLoadingMessage = true
      api.activate_budgeting(payload).then((res) => {
        this.retrieveVenueInformation()

        var data = res.data
        Utils.alert('', `Budgeting tool successfully ${isBudgetingActivated ? 'activated' : 'deactivated'}.`, 'success')
        this.isLoadingMessage = false
        this.showBudgetingAlert = false
      })
    },

    enableRevenueForecasting(isRevenueTargetForecastActivated) {
      var payload = {
        isRevenueTargetForecastActivated: isRevenueTargetForecastActivated,
        venueId: this.$route.params.id
      }
      this.isLoadingMessage = true
      api.activateTargetRevenueForecast(payload).then((res) => {
        this.retrieveVenueInformation()

        var data = res.data
        Utils.alert('', `Revenue forecasting tool successfully ${isRevenueTargetForecastActivated ? 'activated' : 'deactivated'}.`, 'success')
        this.isLoadingMessage = false
        this.showRevenueForecastingAlert = false
      })
    },

    activateAccountingPlatform(isAccountingPlatformActivated) {
      var payload = {
        isAccountingPlatformActivated: isAccountingPlatformActivated,
        venueId: this.$route.params.id
      }
      this.isLoadingMessage = true
      api.activateAccountingPlatform(payload).then((res) => {
        this.retrieveVenueInformation()

        var data = res.data
        Utils.alert('', `Accounting platform successfully ${isAccountingPlatformActivated ? 'activated' : 'deactivated'}.`, 'success')
        this.showXero = false
        this.isLoadingMessage = false
      })
    },

    activateEodSplit(isEodSplit) {
      var payload = {
        isEodSplit: isEodSplit,
        venueId: this.$route.params.id
      }
      this.isLoadingMessage = true
      api.activateEodSplit(payload).then((res) => {
        this.retrieveVenueInformation()

        var data = res.data
        if (data.code == 0) {
          Utils.alert('', `EOD Split  successfully ${isEodSplit ? 'activated' : 'deactivated'}.`, 'success')
          this.showSplitEod = false
          this.isLoadingMessage = false
        } else {
          Utils.alert('', data.message, 'error')
          this.isLoadingMessage = false
        }
      })
    },

    enableDeputySalaryStaff(enableDeputySalaryStaff) {
      var payload = {
        enableDeputySalaryStaff: enableDeputySalaryStaff,
        venueId: this.$route.params.id
      }
      this.isLoadingMessage = true
      api.activateDeputySalary(payload).then((res) => {
        this.retrieveVenueInformation()

        let data = res.data
        if (data.code == 0) {
          Utils.alert('', `Deputy salary staff successfully ${enableDeputySalaryStaff ? 'enable' : 'disable'}.`, 'success')
        } else {
          Utils.alert('',"Please link this venue to Deputy before enabling or disabling this feature.", 'error')
        }
        this.isLoadingMessage = false
        this.isEnableDeputySalary = false
      })
    },

    peisoLiteProController() {
      this.showPeisoLiteAlert = true
    },

    testOne() {
      console.log('testOne')
    },

  }
}
</script>

<style lang="scss" scoped>

@import 'static/scss/colors';
@import 'static/scss/fonts/fonts';
.con{
  padding-bottom: 110px;
}
.select-area{
  li{

    @include pingfang-font(18px, 24px, 600, $white) {
      letter-spacing: 0.2px;
      margin-bottom: 20px;
      cursor: pointer;
      background-size: 24px auto;
      background-position: left center;
      background-repeat: no-repeat;
      background-image: url('../../../assets/unselect.png');
      padding-left: 30px;
      box-sizing: border-box;
    }
  }
  .selected{
    background-image: url('../../../assets/selected.png');
  }
}
.unregular-wrp{
  width: 100%;
  position: relative;
  .lft{
    width: 64%;
    float: left;
    box-sizing: border-box;
    padding-right: 15px;
  }
  .rgt{
    width: 35.8%;
    float: right;
    box-sizing: border-box;
    padding-left: 15px;
  }
}
.bdgWrp{
  width: 100%;
  margin-bottom: 30px;
  background: #2B3444;
  box-sizing: border-box;
  padding: 50px 30px 0 30px;
  position: relative;
  .column{
    float: left;
    width: 50%;
    box-sizing: border-box;
  }
  .column:nth-child(1){
    padding-right: 15px;
  }
  h2{
    font-size: 14px;
    line-height: 16px;
    margin-bottom: 10px;
    color: #fff;
  }
  h3{
    font-size: 20px;
    line-height: 28px;
    margin-bottom: 50px;
    color: #fff;
    span{
      display: inline-block;
      margin-left: 10px;
      width: 20px;
      height: 14px;
      background-size: contain;
      background-position: center center;
      background-repeat: no-repeat;
      background-image: url('../../../assets/e2.png');
      cursor: pointer;
    }
    .show{
      background-image: url('../../../assets/e.png');
    }
  }
  .edit-table-show{
    margin-bottom: 50px;
  }

  .subscription-label {
    @include montserrat-font(18px, 150%, 700, $white);
  }
}
.bot{
  width: 100%;
  min-width: 1024px;
  height:80px;
  background:rgba(43,52,68,1);
  box-shadow:0px -2px 4px 0px rgba(0,0,0,0.1);
  position: fixed;
  left: 0;
  width: 100%;
  bottom: 0;
  z-index: 5;
  box-sizing: border-box;
  padding: 20px 160px 0 160px;

  .remove {
    margin-left: 30px;
  }
}

button{


  @include pingfang-font(18px, normal, 500, $white) {
    outline: none;
    width:150px;
    height:40px;
    background-color: transparent;
    cursor: pointer;
    float: left;
    display: block;
  }
}
.dark{
  border:2px solid rgba(255,255,255,1);
  color: #fff;
  margin-right: 30px;
}
.light{
  border:2px solid rgba(234,55,150,1);
  color: #EA3796;
  float: right;
  margin: 0 10px;
}

.impersonate {
  position: absolute;
  top: 10px;
  right: 10px;
}

</style>



// WEBPACK FOOTER //
// src/components/account/venueInfo/index.vue